import AMapLoader from '@amap/amap-jsapi-loader';

const install = (Vue) => {
    AMapLoader.load({
        key: '11cc7cde5b059925fc67c60ea592ddae', // key
        plugins: ["AMap.Geocoder", 'Map3D', 'AMap.Pixel'], // 插件
        version:'2.0',
        Loca:{                // 是否加载 Loca， 缺省不加载
            "version": '2.0.0'  // Loca 版本，缺省 1.3.2
        },
    }).then((AMap,b)=>{
        Vue.prototype.$Amap = AMap
        window.AMap = AMap
    }).catch(err=>{
        throw(new Error('加载高德地图失败：'+err,))
    })
}
export default {
    install,
}